'use client';
// @ts-ignore
import Tempus from "@studio-freight/tempus";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useLayoutEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { ReactLenis, useLenis } from "lenis/react";

export function SmoothScroller() {
    const lenis = useLenis();

    const pathname = usePathname();
    //const searchParams = useSearchParams();
    
    useEffect(() => {
        // window.scrollTo(0, 0);
        
        if (!lenis) return;
        lenis.scrollTo(0, { immediate: true });
    }, [pathname, lenis]);

    useLayoutEffect(() => {
        if (!lenis) return;

        const resize = setInterval(() => {
            lenis!.resize();
        }, 150);

        function onFrame(time: number) {
            lenis!.raf(time);
        }

        const unsubscribe = Tempus.add(onFrame);

        lenis.on('scroll', ScrollTrigger.update)

        return () => {
            unsubscribe();
            clearInterval(resize);
        };
    }, [lenis]);
    
    return (<></>);
}


export function LenisProvider({
    children,
    options,
    ...props
}: {
    children: React.ReactNode;
    options?: any;
}) {
    return (
        <ReactLenis root {...props}>
            {children}
        </ReactLenis>
    );
}